import { Options } from "./options";

export class Drmsetting {
  options:Options;
  }

 
